import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface MerchantTabSearch {
  contractRoute: string;
  contractRouteName: string;
  merchantName: string;
  siteId: string;
  gwCompanyNo: string;
  timestamp: number;
}

const initialState = {} as MerchantTabSearch;

const searchStore = createSlice({
  name: "merchant-tab",
  initialState,
  reducers: {
    createSearchCondition: (
      state,
      action: PayloadAction<MerchantTabSearch>
    ) => {
      const {
        contractRoute,
        contractRouteName,
        merchantName,
        siteId,
        gwCompanyNo: gwCompany,
        timestamp,
      } = action.payload;
      state.contractRoute = contractRoute;
      state.contractRouteName = contractRouteName;
      state.merchantName = merchantName;
      state.siteId = siteId;
      state.gwCompanyNo = gwCompany;
      state.timestamp = timestamp;
    },
  },
});

export const { createSearchCondition } = searchStore.actions;

export default searchStore.reducer;
